import { gql } from '@apollo/client'

export const CHANGE_VEHICLES_V2 = gql`
  mutation ChangeVehiclesV2 {
    changeVehiclesV2 {
      id
    }
  }
`

export const CREATE_TVEHICLE = gql`
  mutation CreateTVehicle($input: CreateTVehicleInput!) {
    createTVehicle(input: $input) {
      id
    }
  }
`

export const CHANGE_VEHICLE_FEATURES = gql`
  mutation ChangeVehicleFeatures($id: UUID!, $input: ChangeTVehicleFeaturesInput!) {
    changeTVehicleFeatures(id: $id, input: $input)
  }
`

export const CHANGE_ODOMETER_READING = gql`
  mutation ChangeOdometerReading($id: UUID!, $input: ChangeTVehicleOdometerReadingInput!) {
    changeTVehicleOdometerReading(id: $id, input: $input)
  }
`

export const CHANGE_LICENSE_PLATES = gql`
  mutation ChangeLicensePlates($id: UUID!, $input: ChangeTVehicleLicensePlatesInput!) {
    changeTVehicleLicensePlates(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_DETAILS = gql`
  mutation ChangeVehicleDetails($id: UUID!, $input: ChangeTVehicleDetailsInput!) {
    changeTVehicleDetails(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_CARDS = gql`
  mutation ChangeVehicleCards($id: UUID!, $input: ChangeTVehicleCardsInput!) {
    changeTVehicleCards(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_DRIVERS = gql`
  mutation ChangeVehicleDrivers($id: UUID!, $input: ChangeTVehicleDriversInput!) {
    changeTVehicleDrivers(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_INSURANCE_POLICY = gql`
  mutation ChangeInsurancePolicy($id: UUID!, $input: ChangeTVehicleInsurancePolicyInput!) {
    changeTVehicleInsurancePolicy(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_REGISTRATION_DETAILS = gql`
  mutation ChangeVehicleRegistrationDetails($id: UUID!, $input: ChangeTVehicleRegistrationDetailsInput!) {
    changeTVehicleRegistrationDetails(id: $id, input: $input)
  }
`

export const CHANGE_VEHICLE_DOCUMENTS = gql`
  mutation ChangeVehicleDocuments($id: UUID!, $input: ChangeTVehicleDocumentsInput!) {
    changeTVehicleDocuments(id: $id, input: $input)
  }
`

export const DEACTIVATE_VEHICLE = gql`
  mutation DeactivateVehicle($id: UUID!, $input: DeactivateVehicleInput!) {
    deactivateVehicle(id: $id, input: $input)
  }
`

export const ACTIVATE_VEHICLE = gql`
  mutation ActivateVehicle($id: UUID!) {
    activateVehicle(id: $id)
  }
`
